// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Home {\n  height: 100%;\n  overflow-y: auto;\n  background-color: var(--color-bg-dark);\n}", ""]);
// Exports
module.exports = exports;
